"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const AddressesController_1 = __importDefault(require("./AddressesController"));
exports.default = AddressesController_1.default;
